/**
 * HRAnnouncementService
 * HR-admin endpoints for announcements: CRUD plus publish / archive lifecycle
 * actions and attachment management.
 * Route: api/hrannouncements
 */
import { CrudService } from '../base/CrudService';
export class HRAnnouncementService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? HRAnnouncementService.DEFAULT_SERVICE_PATH,
            basePath: HRAnnouncementService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Admin list endpoint returns hydrated ModelViews (with status/type/attachments). */
    async listAll() {
        const res = await this.http.get(this.buildUrl());
        return res?.data ?? [];
    }
    /** Admin single-row endpoint returns a hydrated ModelView. */
    async getView(id) {
        const res = await this.http.get(this.buildUrl(String(id)));
        return res?.data ?? null;
    }
    /** Flips the row to Published, stamps PublishedAt, and triggers the broadcast. */
    async publish(id) {
        const res = await this.http.post(this.buildUrl(`${id}/publish`));
        return res?.data ?? null;
    }
    /** Flips the row to Archived — hidden from the staff feed. */
    async archive(id) {
        const res = await this.http.post(this.buildUrl(`${id}/archive`));
        return res?.data ?? null;
    }
    async listAttachments(id) {
        const res = await this.http.get(this.buildUrl(`${id}/attachments`));
        return res?.data ?? [];
    }
    async addAttachment(id, attachment) {
        const res = await this.http.post(this.buildUrl(`${id}/attachments`), attachment);
        return res?.data ?? null;
    }
    async removeAttachment(id, attachmentId) {
        const res = await this.http.delete(this.buildUrl(`${id}/attachments/${attachmentId}`));
        return res?.success ?? false;
    }
}
HRAnnouncementService.DEFAULT_SERVICE_PATH = 'hr';
HRAnnouncementService.BASE_PATH = 'api/hrannouncements';
//# sourceMappingURL=HRAnnouncementService.js.map